import { useEffect } from "react"
import { useTimeOnPage } from "hooks/useTimeOnPage"
import { upsertPostMetric } from "../api/metrics"

/**
 * A client-side hook for tracking post page metrics (views and read time).
 */
export default function usePostPageMetrics({
  blogId,
  postId,
}: {
  blogId: string
  postId: string
}) {
  useEffect(() => {
    // Increment the post view metric.
    if (blogId && postId) {
      upsertPostMetric(blogId, postId, true)
    }
  }, [])

  // Track how long user has spent on the page.
  const storeTimeOnPageMetric = (finalTimeOnPage: number) => {
    if (!blogId || !postId) return

    // This is more reliable. If it's not present, fallback to fetch.
    if (navigator.sendBeacon) {
      // Send the time on page metric to the server.
      const blob = new Blob(
        [
          JSON.stringify({
            blogId,
            postId,
            incrementPostView: false,
            incrementReadTime: finalTimeOnPage,
          }),
        ],
        { type: "text/plain" }
      )
      navigator.sendBeacon(`/api/metrics/post-track`, blob)
    } else {
      // This is called when a user has stopped looking at the page, so we're passing in `false` for the boolean to increment the page view counter.
      upsertPostMetric(blogId, postId, false, finalTimeOnPage)
    }
  }
  useTimeOnPage(storeTimeOnPageMetric)
}
